import React, { memo } from 'react'
import { Button, Tag } from 'antd';
import { Link } from 'gatsby';
import arrow from '../images/arrow.png'
import reactBgImg from '../images/react-js 1.png'
import dynamicsBgImg from "../images/msdynamics 1.png"
import DotNetbgImg from '../images/netcore 1.png'
import flutterbgImg from '../images/flutter 1.png'
import odoobgImg from '../images/odoo 1.png'
import aiEngineerImg from '../images/techstack/icons8-pytorch-100.png'
import IconsAdded from './IconsAdded';

const cards = [
  {
    logo: reactBgImg,
    title: 'Senior React.js Frontend Developer',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: 'Discover a wide array of top ReactJS experts meticulously selected through rigorous evaluation. Our professionals are skilled in React Router, Redux, and GraphQL — empowering you to build standout web applications that outpace the competition.',
    tags: ['Next.js', 'Gatsby', 'Redux', 'Axios', 'Formik', 'React Router', 'Material-UI', 'ANT Design', 'React Query', 'Styled-components'],
    link: '/services/staffAugmentationLetsDiscuss?topic=rjs',
    rate: '$3,500/Month',
  },
  {
    logo: dynamicsBgImg,
    title: 'Microsoft Dynamics 365 F&O Developer',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: 'Discover skilled Dynamics 365 F&O developers crafting tailored business solutions. Our professionals bring expertise in X++, Power Platform, and D365 integrations — enabling the development of robust financial and operational systems.',
    tags: ['X++ Language', 'Retail Module', 'Supply Chain', 'Integration & Extensions', 'Reporting & Analytics', 'Upgrade & Migration'],
    link: '/services/staffAugmentationLetsDiscuss?topic=drd',
    rate: '$4,000/Month',
  },
  {
    logo: DotNetbgImg,
    title: 'Senior .NET / C# Backend Developer',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: "Access a pool of seasoned .NET professionals proficient in the framework's full potential. Our dedicated experts are well-versed in ASP.NET, C#, and .NET Core — empowering you to develop scalable, innovative solutions.",
    tags: ['ASP.NET Core', 'C#', 'SignalR', 'Dapper', 'Azure SDK', 'AutoMapper', 'Hangfire', 'Json.NET'],
    link: '/services/staffAugmentationLetsDiscuss?topic=ned',
    rate: '$3,000/Month',
  },
  {
    logo: flutterbgImg,
    title: 'Flutter Mobile App Developer',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: 'Discover a pool of adept Flutter developers skilled in creating cross-platform mobile applications. Our experts are proficient in Dart, Flutter framework, and UI/UX design — delivering high-performing apps across iOS and Android.',
    tags: ['Dart', 'Firebase', 'GetX', 'RxDart', 'Riverpod', 'Hive', 'Flutter Hooks', 'Dio'],
    link: '/services/staffAugmentationLetsDiscuss?topic=fed',
    rate: '$3,000/Month',
  },
  {
    logo: odoobgImg,
    title: 'Odoo ERP Developer & Consultant',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: 'Access a talent pool of seasoned Odoo developers proficient in customising and implementing Odoo ERP solutions. Our experts in Python, Odoo framework, and ERP customisation create tailored solutions that streamline your operations.',
    tags: ['Odoo Framework', 'Python', 'PostgreSQL', 'QWeb', 'OWL Components', 'XML-RPC', 'External APIs'],
    link: '/services/staffAugmentationLetsDiscuss?topic=oed',
    rate: '$3,000/Month',
  },
  {
    logo: aiEngineerImg,
    title: 'AI / ML Engineer',
    employment: 'Full Time',
    availability: 'Available Now',
    desc: 'Access battle-tested AI/ML engineers who design, train, and deploy production-grade machine learning models. Our experts build LLM-powered applications, recommendation systems, and intelligent automation pipelines tailored to your business data.',
    tags: ['Python', 'TensorFlow', 'PyTorch', 'LangChain', 'OpenAI API', 'Scikit-learn', 'Hugging Face', 'MLOps', 'RAG', 'Vector DBs'],
    link: '/services/staffAugmentationLetsDiscuss?topic=aie',
    rate: '$5,000/Month',
  },
]

const OurAugmentationOfferings = () => {
  return (
    <div className='OurAugmentationOfferings position-relative'>
      <h1 className='heading'>Find the Right Developer for Your Project</h1>
      <div className='our-container-offering'>
        {cards.map((card, i) => (
          <div key={i} className="aug-card">
            <div className="aug-card-header">
              {/* <img src={card.logo} className="aug-logo" alt={card.title} /> */}
              <div className="aug-company-info">
                <h2 className="aug-job-title">{card.title}</h2>
                <div className="aug-meta">
                  <span className="aug-type">{card.employment}</span>
                  <span className="aug-avail">{card.availability}</span>
                </div>
              </div>
              <span className="aug-bolt">&#9889;</span>
            </div>
            <p className="aug-desc">{card.desc}</p>
            <div className="aug-tags">
              {card.tags.map((tag, j) => <Tag key={j}>{tag}</Tag>)}
            </div>
            <div className="aug-footer">
              <span className="aug-rate">{card.rate}</span>
              <Link to={card.link}>
                <Button className="aug-btn">
                  Let's Discuss
                  <img src={arrow} width='16' style={{ marginLeft: '6px' }} alt='arrow' />
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
      {/* <IconsAdded/> */}
    </div>
  )
}

export default memo(OurAugmentationOfferings)
